import axios from 'axios'
import { Auth } from 'aws-amplify'
import { HttpRequest, HttpResponse } from '../../data/protocols'

export class AxiosHttpClient {
  api: any

  constructor(private readonly baseUrl: string | undefined) {
    const api = axios
    api.interceptors.response.use(this.handleSuccess, this.handleError)
    this.api = api
  }

  async request({
    headers,
    method,
    url,
    data,
    params
  }: HttpRequest): Promise<HttpResponse> {
    let axiosResponse

    try {
      const token = await this.updateAmplifyToken()
      axiosResponse = await this.api.request({
        url: this.baseUrl + url,
        method,
        data,
        headers: {
          ...token,
          ...headers
        },
        params
      })
    } catch (error: any) {
      axiosResponse = error.response
    }

    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data
    }
  }

  updateAmplifyToken = async () => {
    try {
      const session = await Auth.currentSession()
      return {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`
      }
    } catch (_) {
      return {}
    }
  }

  handleSuccess = (response: any) => {
    return response
  }

  handleError = (error: { response: { status: any } }) => {
    const { status } = error.response
    switch (status) {
      case 401:
        if (!window.location.pathname.includes('/importar-arquivo/')) {
          this.redirectTo(document, '/sair')
        }
        break
      case 403:
        this.redirectTo(document, '/403')
        break
      case 404:
        this.redirectTo(document, '/404')
        break
    }
    return Promise.reject(error)
  }

  redirectTo = (document: { location: any }, path: any) => {
    document.location = path
  }
}
